"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyCodes = void 0;
/**
 * List of all codes according to ISO4217
 * https://www.iso.org/iso-4217-currency-codes.html
 */
var CurrencyCodes;
(function (CurrencyCodes) {
    CurrencyCodes["AED"] = "AED";
    CurrencyCodes["AFN"] = "AFN";
    CurrencyCodes["ALL"] = "ALL";
    CurrencyCodes["AMD"] = "AMD";
    CurrencyCodes["ANG"] = "ANG";
    CurrencyCodes["AOA"] = "AOA";
    CurrencyCodes["ARS"] = "ARS";
    CurrencyCodes["AUD"] = "AUD";
    CurrencyCodes["AWG"] = "AWG";
    CurrencyCodes["AZN"] = "AZN";
    CurrencyCodes["BAM"] = "BAM";
    CurrencyCodes["BBD"] = "BBD";
    CurrencyCodes["BDT"] = "BDT";
    CurrencyCodes["BGN"] = "BGN";
    CurrencyCodes["BHD"] = "BHD";
    CurrencyCodes["BIF"] = "BIF";
    CurrencyCodes["BMD"] = "BMD";
    CurrencyCodes["BND"] = "BND";
    CurrencyCodes["BOB"] = "BOB";
    CurrencyCodes["BOV"] = "BOV";
    CurrencyCodes["BRL"] = "BRL";
    CurrencyCodes["BSD"] = "BSD";
    CurrencyCodes["BTN"] = "BTN";
    CurrencyCodes["BWP"] = "BWP";
    CurrencyCodes["BYN"] = "BYN";
    CurrencyCodes["BZD"] = "BZD";
    CurrencyCodes["CAD"] = "CAD";
    CurrencyCodes["CDF"] = "CDF";
    CurrencyCodes["CHE"] = "CHE";
    CurrencyCodes["CHF"] = "CHF";
    CurrencyCodes["CHW"] = "CHW";
    CurrencyCodes["CLF"] = "CLF";
    CurrencyCodes["CLP"] = "CLP";
    CurrencyCodes["CNY"] = "CNY";
    CurrencyCodes["COP"] = "COP";
    CurrencyCodes["COU"] = "COU";
    CurrencyCodes["CRC"] = "CRC";
    CurrencyCodes["CUC"] = "CUC";
    CurrencyCodes["CUP"] = "CUP";
    CurrencyCodes["CVE"] = "CVE";
    CurrencyCodes["CZK"] = "CZK";
    CurrencyCodes["DJF"] = "DJF";
    CurrencyCodes["DKK"] = "DKK";
    CurrencyCodes["DOP"] = "DOP";
    CurrencyCodes["DZD"] = "DZD";
    CurrencyCodes["EGP"] = "EGP";
    CurrencyCodes["ERN"] = "ERN";
    CurrencyCodes["ETB"] = "ETB";
    CurrencyCodes["EUR"] = "EUR";
    CurrencyCodes["FJD"] = "FJD";
    CurrencyCodes["FKP"] = "FKP";
    CurrencyCodes["GBP"] = "GBP";
    CurrencyCodes["GEL"] = "GEL";
    CurrencyCodes["GHS"] = "GHS";
    CurrencyCodes["GIP"] = "GIP";
    CurrencyCodes["GMD"] = "GMD";
    CurrencyCodes["GNF"] = "GNF";
    CurrencyCodes["GTQ"] = "GTQ";
    CurrencyCodes["GYD"] = "GYD";
    CurrencyCodes["HKD"] = "HKD";
    CurrencyCodes["HNL"] = "HNL";
    CurrencyCodes["HTG"] = "HTG";
    CurrencyCodes["HUF"] = "HUF";
    CurrencyCodes["IDR"] = "IDR";
    CurrencyCodes["ILS"] = "ILS";
    CurrencyCodes["INR"] = "INR";
    CurrencyCodes["IQD"] = "IQD";
    CurrencyCodes["IRR"] = "IRR";
    CurrencyCodes["ISK"] = "ISK";
    CurrencyCodes["JMD"] = "JMD";
    CurrencyCodes["JOD"] = "JOD";
    CurrencyCodes["JPY"] = "JPY";
    CurrencyCodes["KES"] = "KES";
    CurrencyCodes["KGS"] = "KGS";
    CurrencyCodes["KHR"] = "KHR";
    CurrencyCodes["KMF"] = "KMF";
    CurrencyCodes["KPW"] = "KPW";
    CurrencyCodes["KRW"] = "KRW";
    CurrencyCodes["KWD"] = "KWD";
    CurrencyCodes["KYD"] = "KYD";
    CurrencyCodes["KZT"] = "KZT";
    CurrencyCodes["LAK"] = "LAK";
    CurrencyCodes["LBP"] = "LBP";
    CurrencyCodes["LKR"] = "LKR";
    CurrencyCodes["LRD"] = "LRD";
    CurrencyCodes["LSL"] = "LSL";
    CurrencyCodes["LYD"] = "LYD";
    CurrencyCodes["MAD"] = "MAD";
    CurrencyCodes["MDL"] = "MDL";
    CurrencyCodes["MGA"] = "MGA";
    CurrencyCodes["MKD"] = "MKD";
    CurrencyCodes["MMK"] = "MMK";
    CurrencyCodes["MNT"] = "MNT";
    CurrencyCodes["MOP"] = "MOP";
    CurrencyCodes["MRU"] = "MRU";
    CurrencyCodes["MUR"] = "MUR";
    CurrencyCodes["MVR"] = "MVR";
    CurrencyCodes["MWK"] = "MWK";
    CurrencyCodes["MXN"] = "MXN";
    CurrencyCodes["MXV"] = "MXV";
    CurrencyCodes["MYR"] = "MYR";
    CurrencyCodes["MZN"] = "MZN";
    CurrencyCodes["NAD"] = "NAD";
    CurrencyCodes["NGN"] = "NGN";
    CurrencyCodes["NIO"] = "NIO";
    CurrencyCodes["NOK"] = "NOK";
    CurrencyCodes["NPR"] = "NPR";
    CurrencyCodes["NZD"] = "NZD";
    CurrencyCodes["OMR"] = "OMR";
    CurrencyCodes["PAB"] = "PAB";
    CurrencyCodes["PEN"] = "PEN";
    CurrencyCodes["PGK"] = "PGK";
    CurrencyCodes["PHP"] = "PHP";
    CurrencyCodes["PKR"] = "PKR";
    CurrencyCodes["PLN"] = "PLN";
    CurrencyCodes["PYG"] = "PYG";
    CurrencyCodes["QAR"] = "QAR";
    CurrencyCodes["RON"] = "RON";
    CurrencyCodes["RSD"] = "RSD";
    CurrencyCodes["RUB"] = "RUB";
    CurrencyCodes["RWF"] = "RWF";
    CurrencyCodes["SAR"] = "SAR";
    CurrencyCodes["SBD"] = "SBD";
    CurrencyCodes["SCR"] = "SCR";
    CurrencyCodes["SDG"] = "SDG";
    CurrencyCodes["SEK"] = "SEK";
    CurrencyCodes["SGD"] = "SGD";
    CurrencyCodes["SHP"] = "SHP";
    CurrencyCodes["SLE"] = "SLE";
    CurrencyCodes["SLL"] = "SLL";
    CurrencyCodes["SOS"] = "SOS";
    CurrencyCodes["SRD"] = "SRD";
    CurrencyCodes["SSP"] = "SSP";
    CurrencyCodes["STN"] = "STN";
    CurrencyCodes["SVC"] = "SVC";
    CurrencyCodes["SYP"] = "SYP";
    CurrencyCodes["SZL"] = "SZL";
    CurrencyCodes["THB"] = "THB";
    CurrencyCodes["TJS"] = "TJS";
    CurrencyCodes["TMT"] = "TMT";
    CurrencyCodes["TND"] = "TND";
    CurrencyCodes["TOP"] = "TOP";
    CurrencyCodes["TRY"] = "TRY";
    CurrencyCodes["TTD"] = "TTD";
    CurrencyCodes["TWD"] = "TWD";
    CurrencyCodes["TZS"] = "TZS";
    CurrencyCodes["UAH"] = "UAH";
    CurrencyCodes["UGX"] = "UGX";
    CurrencyCodes["USD"] = "USD";
    CurrencyCodes["USN"] = "USN";
    CurrencyCodes["UYI"] = "UYI";
    CurrencyCodes["UYU"] = "UYU";
    CurrencyCodes["UYW"] = "UYW";
    CurrencyCodes["UZS"] = "UZS";
    CurrencyCodes["VED"] = "VED";
    CurrencyCodes["VES"] = "VES";
    CurrencyCodes["VND"] = "VND";
    CurrencyCodes["VUV"] = "VUV";
    CurrencyCodes["WST"] = "WST";
    CurrencyCodes["XAF"] = "XAF";
    CurrencyCodes["XAG"] = "XAG";
    CurrencyCodes["XAU"] = "XAU";
    CurrencyCodes["XBA"] = "XBA";
    CurrencyCodes["XBB"] = "XBB";
    CurrencyCodes["XBC"] = "XBC";
    CurrencyCodes["XBD"] = "XBD";
    CurrencyCodes["XCD"] = "XCD";
    CurrencyCodes["XDR"] = "XDR";
    CurrencyCodes["XOF"] = "XOF";
    CurrencyCodes["XPD"] = "XPD";
    CurrencyCodes["XPF"] = "XPF";
    CurrencyCodes["XPT"] = "XPT";
    CurrencyCodes["XSU"] = "XSU";
    CurrencyCodes["XTS"] = "XTS";
    CurrencyCodes["XUA"] = "XUA";
    CurrencyCodes["XXX"] = "XXX";
    CurrencyCodes["YER"] = "YER";
    CurrencyCodes["ZAR"] = "ZAR";
    CurrencyCodes["ZMW"] = "ZMW";
    CurrencyCodes["ZWL"] = "ZWL";
})(CurrencyCodes = exports.CurrencyCodes || (exports.CurrencyCodes = {}));
//# sourceMappingURL=currencyEnums.js.map